import AccountingCoordinator from "../shared/documentInfrastructure/AccountingCoordinator.js";

/**
 * Coordinator for the Forecast wizard company settings. It provides
 * the callbacks when the wizard is done/cancelled.
 */
export default class CompanySettingsForecastWizardDocumentCoordinator extends AccountingCoordinator {
	_setupContentCallbacks() {
		return {
			onSuccess: async () => {
				await this._documentState.updateDefaultConfiguration();

				this._redirectTo("company-settings");
			},
			onAbort: () => {
				this._redirectTo("company-settings");
			},
		};
	}
}
